import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Masked line-by-line reveal for hero headlines.
 * `lines` is an array of strings or JSX nodes; each renders on its own masked row.
 */
export const SplitReveal = ({ lines = [], className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
